import {UntypedFormGroup, ValidationErrors, AbstractControl } from '@angular/forms';

export const brokerReferralValidator = (formGroup: AbstractControl): ValidationErrors | null => {
	const name = formGroup.get('name').value;
	const email = formGroup.get('email').value;
	const phone = formGroup.get('phone').value;

	if (![name, email, phone].every(Boolean)) {
		return { hasDetail: true };
	}

	return null;
};
